import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
declare let $: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    Location, {
        provide: LocationStrategy,
        useClass: PathLocationStrategy
    }
  ]
})
export class AppComponent implements OnInit {

  title = 'my3clicks-website';

  location: any;
  routerSubscription: any;

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.loadPreloder();
  }

  loadPreloder() {
    this.router.events
    .subscribe((event) => {
      if( event instanceof NavigationStart ){
          $('.loader').fadeIn('slow');
      }
    });
    this.routerSubscription = this.router.events
    .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
    .subscribe(event  => {
        $.getScript('../assets/js/custom.js');
        $('.loader').fadeOut('slow');
        this.location = this.router.url;
        if(!(event instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
    });

  }


}
